import { inject, Injectable } from '@angular/core'
import { CacheService } from '@core/services/cache/cache.service'
import { firstValueFrom } from 'rxjs'
import { SessionService } from 'superlikers-microsites-api'

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  sessionService = inject(SessionService)
  cacheService = inject(CacheService)

  async logout() {
    const response$ = this.sessionService.logout()
    const response = await firstValueFrom(response$)

    window.location.reload()

    return response
  }

  async checkRequirements() {
    const response$ = this.sessionService.checkRequirements()
    const response = await firstValueFrom(response$)

    return response
  }
}
